import {
  ConnectPayoutAccountRequestDto,
  StatusDto,
  WalletsBankAccountsClient,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const walletsBankAccountsClient = new WalletsBankAccountsClient(
  apiConfig,
  undefined,
  axiosInstance
);

const handleConfirmConnectAccount = async (
  connectAccountData: ConnectPayoutAccountRequestDto
): Promise<StatusDto | undefined> => {
  try {
    const response = (
      await walletsBankAccountsClient.connectPayoutAccount(connectAccountData)
    ).data;
    return response;
  } catch {
    return;
  }
};

export { handleConfirmConnectAccount };
